"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OurContractModalBody = OurContractModalBody;
const react_1 = __importStar(require("react"));
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const ContractModalBody_1 = require("./ContractModalBody");
const FormContext_1 = require("../../../View/Modals/FormContext");
const react_bootstrap_1 = require("react-bootstrap");
const ContractsController_1 = require("../ContractsController");
const InlineCreateDrawers_1 = require("../../../View/Modals/InlineCreateDrawers");
const aqmMatchService_1 = require("./aqmMatchService");
const ContractStructureTree_1 = require("./ContractStructureTree");
const ChatSpaceSelection_1 = require("./ChatSpaceSelection");
const nipValidator_1 = require("./nipValidator");
/** Text labels for the 3 AQM dedup match states (L11). */
const AQM_MATCH_LABELS = {
    NIP: "Podmiot zostanie powiązany po NIP z istniejącą organizacją w AQM.",
    NAME: "W AQM istnieje już karta o tej samej nazwie (dane niżej). Zapis dopasowuje karty po NIP, nigdy po nazwie — jeśli tego podmiotu nie wysłano wcześniej do AQM, powstanie DRUGA karta. Sprawdź, czy to nie ten sam podmiot.",
    NONE: "Podmiot nie istnieje w AQM — zostanie utworzony automatycznie przy zapisie umowy.",
};
/** Variant for the match-state Alert. */
const AQM_MATCH_VARIANT = {
    NIP: "success",
    NAME: "warning",
    NONE: "info",
};
function OurContractModalBody(props) {
    const { initialData, isEditing } = props;
    const { register, trigger, setValue, watch, formState: { errors }, control, } = (0, FormContext_1.useFormContext)();
    const _type = watch("_type");
    const _employers = watch("_employers");
    const _invoiceBuyer = watch("_invoiceBuyer");
    const [showCreateCity, setShowCreateCity] = (0, react_1.useState)(false);
    const [showCreateEmployer, setShowCreateEmployer] = (0, react_1.useState)(false);
    const [showCreateInvoiceBuyer, setShowCreateInvoiceBuyer] = (0, react_1.useState)(false);
    // AQM match preview state (L11)
    const [matchState, setMatchState] = (0, react_1.useState)(null);
    const [matchLoading, setMatchLoading] = (0, react_1.useState)(false);
    const [matchError, setMatchError] = (0, react_1.useState)(null);
    const prevNipRef = (0, react_1.useRef)(null);
    // Nabywca-FV AQM match (incident 2026-07-17, umowa 871): a buyer NIP that
    // already exists as an AQM org signals the field was swapped with Zamawiający
    // (gmina normally is NOT in AQM). Advisory only — no loading/error UI.
    const [buyerMatch, setBuyerMatch] = (0, react_1.useState)(null);
    const prevBuyerNipRef = (0, react_1.useRef)(null);
    const isAqm = _type?.name === "AQM";
    (0, react_1.useEffect)(() => {
        setValue("_type", initialData?._type, { shouldValidate: true });
        setValue("ourId", initialData?.ourId || "", { shouldValidate: true });
        setValue("_city", initialData?._city, { shouldValidate: true });
        setValue("_admin", initialData?._admin, { shouldValidate: true });
        setValue("_manager", initialData?._manager, { shouldValidate: true });
        setValue("_employers", initialData?._employers, { shouldValidate: true });
        setValue("_invoiceBuyer", initialData?._invoiceBuyer, { shouldValidate: true });
    }, [initialData, setValue]);
    // Keep invoiceBuyerEntityId in lockstep with _invoiceBuyer (server ContractOur.ts derives
    // the FK from _invoiceBuyer.id when present; but on EDIT the previous invoiceBuyerEntityId
    // survives the merge with currentDataItem in GeneralModal, so clearing the picker needs an
    // EXPLICIT null here, not just an absent field, or the old id would stick server-side).
    (0, react_1.useEffect)(() => {
        setValue("invoiceBuyerEntityId", _invoiceBuyer?.id ?? null, { shouldDirty: false });
    }, [_invoiceBuyer, setValue]);
    // Reset match state when switching away from AQM type
    (0, react_1.useEffect)(() => {
        if (!isAqm) {
            setMatchState(null);
            setMatchError(null);
            prevNipRef.current = null;
        }
    }, [isAqm]);
    // Trigger match preview when AQM employer is selected/changed (L11)
    (0, react_1.useEffect)(() => {
        if (!isAqm)
            return;
        const employer = _employers?.[0];
        if (!employer?.taxNumber) {
            setMatchState(null);
            setMatchError(null);
            prevNipRef.current = null;
            return;
        }
        const normalized = (0, nipValidator_1.normalizeNip)(employer.taxNumber);
        if (normalized === prevNipRef.current)
            return; // avoid duplicate calls
        prevNipRef.current = normalized;
        if (!/^\d{10}$/.test(normalized)) {
            // Invalid NIP — don't bother calling match; schema will show error
            setMatchState(null);
            setMatchError(null);
            return;
        }
        let cancelled = false;
        setMatchLoading(true);
        setMatchError(null);
        setMatchState(null);
        (0, aqmMatchService_1.fetchAqmMatch)(normalized, employer.name)
            .then((result) => {
            if (!cancelled)
                setMatchState(result);
        })
            .catch((err) => {
            if (!cancelled) {
                setMatchError(err instanceof Error ? err.message : "Nie udało się sprawdzić dopasowania w AQM.");
            }
        })
            .finally(() => {
            if (!cancelled)
                setMatchLoading(false);
        });
        return () => {
            cancelled = true;
        };
    }, [isAqm, _employers]);
    // Nabywca-FV AQM match check (incident 2026-07-17). Mirrors the employer
    // effect but advisory-only: on error or non-AQM we just clear the warning.
    (0, react_1.useEffect)(() => {
        if (!isAqm || !_invoiceBuyer?.taxNumber) {
            setBuyerMatch(null);
            prevBuyerNipRef.current = null;
            return;
        }
        const normalized = (0, nipValidator_1.normalizeNip)(_invoiceBuyer.taxNumber);
        if (normalized === prevBuyerNipRef.current)
            return;
        prevBuyerNipRef.current = normalized;
        if (!/^\d{10}$/.test(normalized)) {
            setBuyerMatch(null);
            return;
        }
        let cancelled = false;
        (0, aqmMatchService_1.fetchAqmMatch)(normalized, _invoiceBuyer.name)
            .then((result) => {
            if (!cancelled)
                setBuyerMatch(result);
        })
            .catch(() => {
            if (!cancelled)
                setBuyerMatch(null);
        });
        return () => {
            cancelled = true;
        };
    }, [isAqm, _invoiceBuyer]);
    // Expose the match result to the schema and reset the NAME-confirmation on EVERY
    // change of it. matchState is nulled before each lookup and when the employer is
    // cleared or the type leaves AQM, so this one effect covers all reset paths —
    // without it a tick made for one card would survive into a different podmiot.
    (0, react_1.useEffect)(() => {
        setValue("_aqmMatchState", matchState?.match ?? null);
        setValue("aqmNameMatchConfirmed", false);
    }, [matchState, setValue]);
    function handleCityCreated(created) {
        setValue("_city", created, { shouldValidate: true });
    }
    function handleEmployerCreated(created) {
        if (isAqm) {
            // AQM: single employer only
            setValue("_employers", [created], { shouldValidate: true });
        }
        else {
            const current = watch("_employers") || [];
            setValue("_employers", [...current, created], { shouldValidate: true });
        }
    }
    function handleInvoiceBuyerCreated(created) {
        setValue("_invoiceBuyer", created, { shouldValidate: true });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isAqm && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info", className: "mb-3", "data-testid": "aqm-info-banner" },
            react_1.default.createElement("strong", null, "Integracja AQM:"),
            " po zapisaniu umowy podmiot i umowa zostan\u0105 automatycznie przekazane do systemu e-Aquamatic 3.0. Upewnij si\u0119, \u017Ce Zamawiaj\u0105cy ma poprawny NIP.")),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "_city" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Miasto"),
                react_1.default.createElement(BussinesObjectSelectors_1.CitySelector, { showValidationInfo: true, onRequestCreate: () => setShowCreateCity(true) })),
            !isEditing && (react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "_type" },
                react_1.default.createElement(BussinesObjectSelectors_1.ContractTypeSelector, { typesToInclude: "our" })))),
        react_1.default.createElement(ContractModalBody_1.ContractModalBody, { ...props }),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "_manager" },
                react_1.default.createElement(BussinesObjectSelectors_1.PersonSelectorPreloaded, { label: "Koordynator", name: "_manager", repository: MainSetupReact_1.default.personsEnviRepository })),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "_admin" },
                react_1.default.createElement(BussinesObjectSelectors_1.PersonSelectorPreloaded, { label: "Administrator", name: "_admin", repository: MainSetupReact_1.default.personsEnviRepository })),
            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Zamawiaj\u0105cy"),
                react_1.default.createElement(BussinesObjectSelectors_1.EntitySelector, { name: "_employers", multiple: true, onRequestCreate: () => setShowCreateEmployer(true) }),
                isAqm && matchLoading && (react_1.default.createElement("div", { className: "mt-2 text-muted small d-flex align-items-center gap-1", "data-testid": "aqm-match-loading" },
                    react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm" }),
                    react_1.default.createElement("span", null, "Sprawdzanie dopasowania w AQM\u2026"))),
                isAqm && !matchLoading && matchError && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "mt-2 py-1 px-2 small", "data-testid": "aqm-match-error" },
                    "Nie uda\u0142o si\u0119 sprawdzi\u0107 dopasowania: ",
                    matchError)),
                isAqm && !matchLoading && !matchError && matchState && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: AQM_MATCH_VARIANT[matchState.match], className: "mt-2 py-1 px-2 small", "data-testid": `aqm-match-state-${matchState.match}` },
                    AQM_MATCH_LABELS[matchState.match],
                    matchState.organization && (react_1.default.createElement("span", { className: "d-block text-muted" },
                        "AQM: ",
                        matchState.organization.name,
                        matchState.organization.taxNr ? ` (NIP: ${matchState.organization.taxNr})` : "")),
                    matchState.match === "NAME" && (react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", className: "mt-1", id: "aqmNameMatchConfirmed", label: "Sprawdzi\u0142em kart\u0119 powy\u017Cej \u2014 zapisz mimo zbie\u017Cnej nazwy", "data-testid": "aqm-name-match-confirm", ...register("aqmNameMatchConfirmed") })))),
                isAqm && errors.aqmNameMatchConfirmed && (react_1.default.createElement("div", { className: "small text-danger mt-1", "data-testid": "aqm-name-match-error" }, errors.aqmNameMatchConfirmed.message)))),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Nabywca FV (JST \u2014 gmina)"),
                react_1.default.createElement(BussinesObjectSelectors_1.EntitySelector, { name: "_invoiceBuyer", multiple: false, showValidationInfo: false, onRequestCreate: () => setShowCreateInvoiceBuyer(true) }),
                _invoiceBuyer && !_invoiceBuyer.taxNumber && (react_1.default.createElement("div", { className: "small text-warning mt-1" }, "\u26A0 Nabywca FV nie ma NIP \u2014 KSeF odrzuci faktur\u0119 przy wysy\u0142ce. Uzupe\u0142nij NIP podmiotu.")),
                _invoiceBuyer && !_invoiceBuyer.address && (react_1.default.createElement("div", { className: "small text-warning mt-1" }, "\u26A0 Nabywca FV nie ma adresu \u2014 na zwyk\u0142ej fakturze adres jest obowi\u0105zkowy, KSeF odrzuci faktur\u0119 bez niego.")),
                _invoiceBuyer && _employers?.[0] && _invoiceBuyer.id === _employers[0].id && (react_1.default.createElement("div", { className: "small text-warning mt-1", "data-testid": "buyer-equals-employer-warning" }, "\u26A0 Nabywca FV to ten sam podmiot co Zamawiaj\u0105cy \u2014 prawdopodobnie pomy\u0142ka (zamienione pola?). Nabywca FV powinien by\u0107 gmin\u0105 (JST), a Zamawiaj\u0105cy zak\u0142adem.")),
                isAqm && buyerMatch?.match === "NIP" && (react_1.default.createElement("div", { className: "small text-warning mt-1", "data-testid": "buyer-in-aqm-warning" },
                    "\u26A0 Nabywca FV pasuje po NIP do organizacji w AQM",
                    buyerMatch.organization ? ` (${buyerMatch.organization.name})` : "",
                    " \u2014 Nabywca FV to zwykle gmina, kt\u00F3rej NIE ma w AQM. Sprawd\u017A, czy pola z Zamawiaj\u0105cym nie zosta\u0142y zamienione.")))),
        react_1.default.createElement(InlineCreateDrawers_1.CityInlineCreateDrawer, { show: showCreateCity, onHide: () => setShowCreateCity(false), title: "Nowe miasto", repository: ContractsController_1.citiesRepository, onCreated: handleCityCreated }),
        react_1.default.createElement(InlineCreateDrawers_1.EntityInlineCreateDrawer, { show: showCreateEmployer, onHide: () => setShowCreateEmployer(false), title: "Nowy podmiot (zamawiaj\u0105cy)", repository: ContractsController_1.entitiesRepository, onCreated: handleEmployerCreated }),
        react_1.default.createElement(InlineCreateDrawers_1.EntityInlineCreateDrawer, { show: showCreateInvoiceBuyer, onHide: () => setShowCreateInvoiceBuyer(false), title: "Nowy podmiot (Nabywca FV)", repository: ContractsController_1.entitiesRepository, onCreated: handleInvoiceBuyerCreated }),
        !isEditing && react_1.default.createElement(ContractStructureTree_1.ContractStructureTree, null),
        !isEditing && react_1.default.createElement(ChatSpaceSelection_1.ChatSpaceSelection, null)));
}
